import { render, staticRenderFns } from "./OutrightsTabs.vue?vue&type=template&id=a7b8e388"
import script from "./OutrightsTabs.vue?vue&type=script&lang=js"
export * from "./OutrightsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports